import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVersusCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVersusCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.75 8.25H17.25V10.5H15.75V9.75H14.25V11.25H17.25V15.75H12.75V13.5H14.25V14.25H15.75V12.75H12.75V8.25ZM7.75 8.25V12.7968L8.59744 14.2496H8.90256L9.75 12.7968V8.25H11.25V13.2024L9.76411 15.7496H7.73589L6.25 13.2024V8.25H7.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVersusCircle;
